"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _linkaddress = _interopRequireDefault(require("@/components/linkaddress"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'c_custom_nav_tab',
  props: {
    configObj: {
      type: Object
    },
    configNme: {
      type: String
    },
    index: {
      type: null
    }
  },
  components: {
    draggable: _vuedraggable.default,
    linkaddress: _linkaddress.default
  },
  data: function data() {
    return {
      defaults: {},
      configData: {},
      currentTab: 0,
      activeMenuIndex: 0,
      linkKey: 1
    };
  },
  computed: {
    currentMenuArray: function currentMenuArray() {
      if (!this.configData.list || !this.configData.list[this.currentTab]) return [];
      var menuList = this.configData.list[this.currentTab].menuList;
      if (!menuList) return [];
      return Object.keys(menuList).map(function (k) {
        return menuList[k];
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      _this.defaults = _this.configObj;
      _this.configData = _this.configObj[_this.configNme];
    });
  },
  watch: {
    configObj: {
      handler: function handler(nVal) {
        this.defaults = nVal;
        this.configData = nVal[this.configNme];
      },
      deep: true
    }
  },
  methods: {
    switchTab: function switchTab(index) {
      this.currentTab = index;
    },
    getLinkValue: function getLinkValue(item) {
      if (item.info && item.info[1]) {
        return item.info[1].value;
      }
      return '';
    },
    getLink: function getLink(menuIndex) {
      this.activeMenuIndex = menuIndex;
      this.linkKey++;
      this.$refs.linkaddres.dialogVisible = true;
    },
    linkUrl: function linkUrl(url) {
      var menuList = this.configData.list[this.currentTab].menuList;
      var keys = Object.keys(menuList);
      var key = keys[this.activeMenuIndex];
      if (!menuList[key].info[1]) {
        this.$set(menuList[key].info, 1, {
          title: '链接',
          value: '',
          tips: '请选择链接',
          max: 100,
          status: true
        });
      }
      menuList[key].info[1].value = url;
    },
    modalPicTap: function modalPicTap(item, menuIndex) {
      var self = this;
      this.$modalUpload(function (img) {
        if (!img) return;
        item.img = img[0].sattDir;
      });
    },
    deleteItem: function deleteItem(menuIndex) {
      var menuList = this.configData.list[this.currentTab].menuList;
      var keys = Object.keys(menuList);
      if (keys.length <= 1) return;
      var key = keys[menuIndex];
      this.$delete(menuList, key);
      // Rebuild sequential keys
      var newList = {};
      var idx = 0;
      Object.keys(menuList).forEach(function (k) {
        var item = menuList[k];
        newList[idx++] = item;
      });
      this.configData.list[this.currentTab].menuList = newList;
    }
  }
};